// extracted by css-extract-rspack-plugin
export default {"group":"group-O3Ob6G","swatchButton":"swatchButton-xh4v6r","swatch":"swatch-VrNPZJ"};